import { GridApi, IRowNode } from 'ag-grid-community';

type AggregationCellDataT = {
    sum: number;
    average: number;
    count: number;
};

const getColumnIdsWithAggregation = (gridApi: GridApi): string[] => {
    const columns = gridApi.getColumns();
    if (!columns) {
        return [];
    }
    return columns
        .filter((col) => !!col.getColDef().aggFunc)
        .map((col) => col.getColId());
};

export const computeAggregations = (
    gridApi: GridApi,
): Record<string, AggregationCellDataT>[] => {
    const columnIdsWithAggregation = getColumnIdsWithAggregation(gridApi);

    const aggregatedData: Record<string, AggregationCellDataT> = {};

    gridApi.forEachNodeAfterFilter((rowNode: IRowNode) => {
        Object.entries(
            rowNode.data as Record<string, number | null | undefined>,
        ).forEach(([key, value]) => {
            if (
                columnIdsWithAggregation.includes(key) &&
                typeof value === 'number'
            ) {
                if (!(key in aggregatedData)) {
                    aggregatedData[key] = {
                        sum: 0,
                        count: 0,
                        average: 0,
                    };
                }
                aggregatedData[key].sum += value;
                aggregatedData[key].count += 1;
            }
        });
    });

    Object.keys(aggregatedData).forEach((key) => {
        const data = aggregatedData[key];
        if (data.count > 0) {
            data.average = data.sum / data.count;
        }
    });
    return [aggregatedData];
};
